export const DROPDOWN_TYPES = {
  NONE: 'none',
  COMPANIES: 'companies',
  USERS: 'users',
  MAPPINGS: 'mappings',
} as const;

export type DropdownType = typeof DROPDOWN_TYPES[keyof typeof DROPDOWN_TYPES];
